import { CAMPAIGN_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'sales',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Sales',
  },
}

const keys = {
  statKey: 'qualified',
  componentKeys: [CAMPAIGN_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const sales = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { sales }
